// https://github.com/ProseMirror/prosemirror-schema-basic/blob/master/src/schema-basic.js
export const BLOCKQUOTE = 'blockquote';
export const BOOKMARK = 'bookmark';
export const BULLET_LIST = 'bullet_list';
export const CODE_BLOCK = 'code_block';
export const DOC = 'doc';
export const HARD_BREAK = 'hard_break';
export const HEADING = 'heading';
export const HORIZONTAL_RULE = 'horizontal_rule';
export const IMAGE = 'image';
export const LINK = 'link';
export const LIST_ITEM = 'list_item';
export const MATH = 'math';
export const ORDERED_LIST = 'ordered_list';
export const PARAGRAPH = 'paragraph';
export const TABLE = 'table';
export const TABLE_CELL = 'table_cell';
export const TABLE_HEADER = 'table_header';
export const TABLE_ROW = 'table_row';
export const TEXT = 'text';
export const UNDERLINE = 'underline';
export const TAB = 'tab';
